import { render, staticRenderFns } from "./embedding.vue?vue&type=template&id=32cc91c8&scoped=true"
import script from "./embedding.vue?vue&type=script&lang=js"
export * from "./embedding.vue?vue&type=script&lang=js"
import style0 from "./embedding.vue?vue&type=style&index=0&id=32cc91c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc91c8",
  null
  
)

export default component.exports